export default "__VITE_ASSET__goWvesQz__"